module.exports = __webpack_public_path__ + "static/img/C4D0019.715b3c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0019.jpg
// module id = TAWq
// module chunks = 0